import { DataService } from './dataService'
export const seafreightratesServices = {
	addSeafreightrates: async (data) => {
		return DataService.post('/admin/add_seafreightrats', data)
	},

	updateSeafreightrates: async (data) => {
		return DataService.post('/admin/update_seafreightrats' ,data)
	},

    updateSeafreightratestatus: async (data) => {
        return DataService.post('/admin/update_seafreightrats_status' ,data)
    },

    getSeafreightrates: async (data) => {
		return DataService.get('/admin/get_seafreightrats', data)
	},

	importSeafreightratsData: async (data) => {
        return DataService.post('/admin/import_seafreights_data' ,data)
    },

    exportSeafreightratsData: async (data) => {
		return DataService.get('/admin/export_seafreights_data', data)
	},

}